export const recordTelemetry = (record: () => void): void => {
  try {
    record()
  } catch {
    return
  }
}
